import React from 'react';
import { Box, Container } from '@mui/material';

const HeroSection: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        pt: { xs: 4, md: 8 },
        pb: { xs: 6, md: 10 },
        minHeight: { xs: 'auto', md: '85vh' },
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 6 } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            gap: { xs: 4, md: 6 },
          }}
        >
          {/* Left Column - Text */}
          <Box
            sx={{
              flex: { xs: '1', md: '0 0 50%' },
              maxWidth: { xs: '100%', md: '50%' },
            }}
          >
            {/* Main Heading with Red Background Blocks */}
            <Box component="h1" sx={{ mb: 4, m: 0, fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 'inherit' }}>
              {/* Line 1 */}
              <Box
                sx={{
                  display: 'inline-block',
                  backgroundColor: '#dc143c',
                  px: { xs: 1.5, md: 2 },
                  py: { xs: 0.5, md: 1 },
                  mb: 1,
                }}
              >
                <Box
                  component="span"
                  sx={{
                    fontFamily: '"Impact", "Arial Black", sans-serif',
                    fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem', lg: '4.5rem' },
                    lineHeight: 1,
                    fontWeight: 900,
                    color: '#1a1a1a',
                    letterSpacing: '-0.02em',
                  }}
                >
                  Kevyn Franco:
                </Box>
              </Box>

              {/* Line 2 */}
              <Box sx={{ display: 'block' }}>
                <Box
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#dc143c',
                    px: { xs: 1.5, md: 2 },
                    py: { xs: 0.5, md: 1 },
                    mb: 1,
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontFamily: '"Impact", "Arial Black", sans-serif',
                      fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem', lg: '4.5rem' },
                      lineHeight: 1,
                      fontWeight: 900,
                      color: '#1a1a1a',
                      letterSpacing: '-0.02em',
                    }}
                  >
                    Engineering
                  </Box>
                </Box>
              </Box>

              {/* Line 3 */}
              <Box sx={{ display: 'block' }}>
                <Box
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#dc143c',
                    px: { xs: 1.5, md: 2 },
                    py: { xs: 0.5, md: 1 },
                    mb: 1,
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontFamily: '"Impact", "Arial Black", sans-serif',
                      fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem', lg: '4.5rem' },
                      lineHeight: 1,
                      fontWeight: 900,
                      color: '#1a1a1a',
                      letterSpacing: '-0.02em',
                    }}
                  >
                    the Future of AI
                  </Box>
                </Box>
              </Box>

              {/* Line 4 */}
              <Box sx={{ display: 'block' }}>
                <Box
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#dc143c',
                    px: { xs: 1.5, md: 2 },
                    py: { xs: 0.5, md: 1 },
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontFamily: '"Impact", "Arial Black", sans-serif',
                      fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem', lg: '4.5rem' },
                      lineHeight: 1,
                      fontWeight: 900,
                      color: '#1a1a1a',
                      letterSpacing: '-0.02em',
                    }}
                  >
                    Powered
                  </Box>
                </Box>
              </Box>

              {/* Line 5 */}
              <Box sx={{ display: 'block' }}>
                <Box
                  sx={{
                    display: 'inline-block',
                    backgroundColor: '#dc143c',
                    px: { xs: 1.5, md: 2 },
                    py: { xs: 0.5, md: 1 },
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontFamily: '"Impact", "Arial Black", sans-serif',
                      fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem', lg: '4.5rem' },
                      lineHeight: 1,
                      fontWeight: 900,
                      color: '#1a1a1a',
                      letterSpacing: '-0.02em',
                    }}
                  >
                    Products
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Subtitle */}
            <Box
              sx={{
                fontSize: { xs: '1.125rem', md: '1.25rem' },
                fontWeight: 400,
                fontFamily: '"Arial", sans-serif',
                color: '#1a1a1a',
                mt: 4,
              }}
            >
              AI Architect & Senior Software Engineer
            </Box>
          </Box>

          {/* Right Column - Image */}
          <Box
            sx={{
              flex: { xs: '1', md: '0 0 50%' },
              maxWidth: { xs: '100%', md: '50%' },
              width: '100%',
            }}
          >
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            <img
              src="/hero-image.jpg"
              alt="Kevyn Franco Speaking"
              width="500"
              height="685"
              fetchPriority="high"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                objectFit: 'cover',
              }}
              onError={(e: any) => {
                e.target.style.display = 'none';
                e.target.parentElement.style.backgroundColor = '#f0f0f0';
                e.target.parentElement.style.minHeight = '500px';
                e.target.parentElement.style.display = 'flex';
                e.target.parentElement.style.alignItems = 'center';
                e.target.parentElement.style.justifyContent = 'center';
                e.target.parentElement.innerHTML = '<div style="color: #999; font-size: 1.5rem;">Hero Image</div>';
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;